/* eslint-disable max-len */
import { css } from '@emotion/react';

const CustomDatePickerStyles = css`
    .custom-date-picker-input {
        width: 11rem;
        padding: 0;
        border: 1px solid var(--color-border);
        display: flex;
        border-radius: 5px;
        padding: 0.5rem 0.5rem;
        margin-top: 0.5rem;
        color: var(--color-text-primary);
        position: relative;

        input {
            padding: 0;
            border: none;
            outline: none;
            width: 9rem;
        }
        }

        .icons {
            width: 1rem;
            margin: 0px 5px;
        }

        .custom-date-picker-menu {
            position: absolute;
            top: 34px;
            background: var(--color-white);
            border: 1px solid var(--color-border);
            border-radius: 5px;
            width: 265px;
            left: 0;
            right: 0;
            color: var(--color-primary);
            z-index: 999999999999;
        }

        .datepicker-header {
            margin-top: 10px;
        }
    
        .datepicker-content {
            height: 160px;
            overflow-y: auto;
            padding-bottom: 5px;
        }

        .arrows-toggle {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px;
        }

        .arrows-toggle.end {
            justify-content: flex-end;
        }

        .date-heading {
            display: flex;
            justify-content: center;
            padding: 0 5px;

            span {
                width: calc(100% / 7);
                box-sizing: border-box;
                text-align: center;
                font-size: 12px;
            }
        }

        .dates {
            display: flex;
            flex-wrap: wrap;
            padding: 5px;
          
            .date {
                width: calc(100% / 7);
                box-sizing: border-box;
                text-align: center;

            .day {
                display: block;
                margin: 2px;
            }

            .day.selected {
                border: 1px solid var(--color-primary);
                border-radius: 4px;
            }

            .day:hover {
                font-weight: bolder;
            }

            .day.not-current-month {
                color: var(--color-grey);
                pointer-events: none !important;
                cursor: not-allowed;
            }

            .day.disable {
                cursor: default;
                pointer-events: none !important;
            }
          }

          .date.not-current-month {
            cursor: not-allowed;
          }

          .date.disable {
            cursor: default;
          }
        }

        .months {
            display: flex;
            flex-wrap: wrap;
            justify-content: left;
            align-items: space-around;
            height:155px;

            .month {
                width: calc(100% / 3);
                box-sizing: border-box;
                text-align: center;
                height: 30px;
            }

            .month.selected {
                border: 1px solid var(--color-primary);
                border-radius: 4px;
            }

            .month:hover {
                font-weight: bolder;
            }

            .month.disable {
                cursor: default;
            }

            .month span {
                padding: 5px;
                display: inline-flex;
            }

            .month span.disable {
                cursor: default;
                pointer-events: none !important;
            }
        }

        .years {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: space-around;
            height:150px;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 5px;
                height: 5px;
            }
        
            &::-webkit-scrollbar-track {
                background: var(--color-grey-light);
            }
        
            &::-webkit-scrollbar-thumb {
                background: var(--color-grey);
                border-radius: 5px;
            }

            .year {
                width: calc(100% / 3);
                box-sizing: border-box;
                text-align: center;
            }

            .year.selected {
                border: 1px solid var(--color-primary);
                border-radius: 4px;
            }

            .year:hover {
                font-weight: bolder;
            }

            .year.disable {
                cursor: default;
            }

            .year span {
                padding: 2px;
                display: inline-flex;
            }

            .year span.disable {
                cursor: default;
                pointer-events: none !important;
            }
        }
    }

    .custom-date-picker-input.custom-date-picker-input-error {
        border: 1px solid var(--color-error);
    }

    span.custom-date-picker-error-message {
        display: block;
        color: var(--color-error);

        i {
            color: var(--color-error);
            padding-right: 2px;
        }
    }
`;

export default CustomDatePickerStyles;
